export enum EBackgroundType {
    COLOR = 0,
    TEXTURE = 1,
    DAYNIGHT = 2,
    IMAGE = 3,
    HWCAMERA = 4
}

export enum EBackgroundImageFitType {
    FILL = 0,
    FIT = 1
}

/*
export enum EBackgroundStandartColors {
    BLACK = "#000000",
    DARK_GREY = "#404040",
    GREY = "#808080",
    LIGHT_GREY = "#C0C0C0",
    WHITE = "#ffffff",
    GRISEOUS = "#8F8FCB",
    LIGHT_SKY_BLUE = "#EEF9FF",
    LIGHT_BLUE = "#B9DCFF",
    CUSTOM = "custom"
}
*/
